import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="#000000"
					image={require('./image.jpg')}
					title={"NFP Marketing"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle david"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>David</strong> on April 13 2018  //  Posted in <strong>Marketing, Advertising</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
								Why NFPs Need To Become Marketing Companies
								</div>
								
								<p>Peter Singer, the Australian philosopher largely responsible for starting the animal rights movement after his book Animal Liberation: A New Ethics for Our Treatment of Animals came out in the 1970’s, has recently taken target at the idea of altruism, or more commonly understood, the act of selfless giving. Traditionally this act has been seen as ‘a good in itself’ with the nature of the act as important, or more so, than its effect. However, Professor Singer asks us to look at giving in the same light as something like spending. Giving should be done in an efficient, effective way with the aim at maximising the final end. He believes we should give or donate in a more rational, rather than emotional, way.</p>

								<img src={require('./example-1.jpg')} alt="Social Media vs Websites Example 2" className="align-left" align="left" />

								<p>Now this sounds pretty much without controversy but the devil is always in the detail. After being on the ABC’s Q&A he was criticised for saying donating to retina replacement programs in a developing country was a much more efficient way of impacting blindness than investing the same amount in a Guide Dog (Seeing Eye Dog). Again, reasonably simple on the surface, but the complainant was a man with a Guide Dog, who was able to study at university with its assistance and who believed he could contribute to society significantly more than if he didn’t have the dog. If that man, for example, goes on to discover a cure saving millions of lives, then his argument will carry significant weight – but then again, any one of the people in the developing world who had retina surgery could make a breakthrough. And around the merry-go-round we go again….</p>

								<p>Why this is important to me is I share Singer’s general view on altruism, though I’m not as confident to push it to its utilitarian conclusions as Professor Singer. When it comes to donating or giving, effort should be made to make sure it is done in the most efficient and effective way. This also applies at the business level. In fact, at the business level, an extra dimension appears.</p>

								<img src={require('./example-2.jpg')} alt="Social Media vs Websites Example 2" className="align-left" align="left" />

								<p>The vast majority of businesses have to spend money on branding campaigns to help spread their reputation – the fishing burley of marketing, you might say. Most do this through newspaper, radio, TV advertisements or social media. The key here is to hook your target market emotionally, and while some advertising works, most of it doesn’t and business owners frequently become frustrated. One sure way to connect emotionally with a target audience is to be associated with something they see as worthwhile and worthy of praise. Local not-for-profit (NFP) organisations are a great cause to support. Through strategic sponsorship, businesses can assist local NFPs while effectively brand marketing themselves. The success of this, however, relies on two conditions.</p>

								<ul className="with-icons">
									<li>
									The NFP must have access to the sponsor’s target market. The NFP must have done effective market research to know who their message reaches and what their market’s main behaviours/interests are. Rather than a carte blanche approach, NFP’s need to strategically target businesses for sponsorship which they know they can assist.
									</li>
									<li>
									The NFP must have an effective marketing strategy. The sponsor needs to be promoted to the target market in an efficient, measurable way in order to determine the success of campaigns. In addition, the NFP needs to provide marketing support for the business on the optimal use of the NFP’s brand in the business’s own marketing efforts. Too often this part of the equation is given little thought.
									</li>
								</ul>

								<p>There in short is why NFPs need to become marketing companies, or at the very least, have some sort of marketing support if they wish to secure ongoing corporate sponsorship and move away from dependence on funding sources like grants. The idea that altruism is selfless may also need to be looked at, particularly given that improving the world also intrinsically benefits oneself. Ethically this begs a question: once a NFP targets a relevant business and offers them an effective marketing campaign, if the business has the means of providing said sponsorship, is it obliged to do it?</p>



							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/WhyNFPsNeed/index.js